webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Howto_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a97ba15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Howto_vue__ = __webpack_require__(101);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Howto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a97ba15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Howto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.$t("howto.header-message")))]),_vm._v(" "),_c('p',{staticClass:"app-msg"},[_vm._v(_vm._s(_vm.$t("howto.header-message-ext")))])]),_vm._v(" "),_c('div',{staticClass:"img-coffee"},[_c('img',{staticClass:"img-coffee-method",attrs:{"src":_vm.imgPath,"alt":"coffee-image."}})]),_vm._v(" "),_c('div',{staticClass:"choose-methods"},[_c('b-form-select',{on:{"change":function($event){_vm.selectMethod($event)}},model:{value:(_vm.curMethod),callback:function ($$v) {_vm.curMethod=$$v},expression:"curMethod"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- "+_vm._s(_vm.$t("cmn.choose-method"))+" --")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t(_vm.map[1].method_name)))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t(_vm.map[2].method_name)))]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v(_vm._s(_vm.$t(_vm.map[3].method_name)))])])],1),_vm._v(" "),(_vm.curMethod)?_c('div',{staticClass:"howto-make",domProps:{"innerHTML":_vm._s(_vm.howtoMake)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0523b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(103);
var normalizeComponent = __webpack_require__(17)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0523b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.$t("pp.header-message")))])]),_vm._v(" "),_c('h2',[_vm._v("個人情報の利用目的")]),_vm._v(" "),_c('p',[_vm._v("　当ブログでは、メールでのお問い合わせ、メールマガジンへの登録などの際に、名前（ハンドルネーム）、メールアドレス等の個人情報をご登録いただく場合がございます。")]),_vm._v(" "),_c('p',[_vm._v("　これらの個人情報は質問に対する回答や必要な情報を電子メールなどをでご連絡する場合に利用させていただくものであり、個人情報をご提供いただく際の目的以外では利用いたしません。")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("個人情報の第三者への開示")]),_vm._v(" "),_c('p',[_vm._v("　当サイトでは、個人情報は適切に管理し、以下に該当する場合を除いて第三者に開示することはありません。")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("個人情報の開示、訂正、追加、削除、利用停止")]),_vm._v(" "),_c('p',[_vm._v("　ご本人からの個人データの開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させていただいた上、速やかに対応させていただきます。")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("アクセス解析ツールについて")]),_vm._v(" "),_c('p',[_vm._v("　当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("広告の配信について")]),_vm._v(" "),_c('p',[_vm._v("　当サイトは第三者配信の広告サービス「Google Adsense グーグルアドセンス」を利用しています。")]),_vm._v(" "),_c('p',[_vm._v("　広告配信事業者は、ユーザーの興味に応じた広告を表示するためにCookie（クッキー）を使用することがあります。")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("免責事項")]),_vm._v(" "),_c('p',[_vm._v("　当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。")]),_vm._v(" "),_c('p',[_vm._v("　当サイトのコンテンツ・情報につきまして、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。")]),_vm._v(" "),_c('p',[_vm._v("　当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("プライバシーポリシーの変更について")]),_vm._v(" "),_c('p',[_vm._v("　当サイトは、個人情報に関して適用される日本の法令を遵守するとともに、本ポリシーの内容を適宜見直しその改善に努めます。")]),_vm._v(" "),_c('p',[_vm._v("　修正された最新のプライバシーポリシーは常に本ページにて開示されます。")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("本人のご了解がある場合")]),_vm._v(" "),_c('li',[_vm._v("法令等への協力のため、開示が必要となる場合")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"links"},[_vm._v("　このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。この規約に関して、詳しくは"),_c('a',{attrs:{"href":"https://www.google.com/analytics/terms/jp.html","target":"_blank","rel":"noopener"}},[_vm._v("ここをクリック")]),_vm._v("してください。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"links"},[_vm._v("　Cookie（クッキー）を無効にする設定およびGoogleアドセンスに関する詳細は「"),_c('a',{attrs:{"href":"https://policies.google.com/technologies/ads?hl=ja","target":"_blank","rel":"noopener"}},[_vm._v("広告 – ポリシーと規約 – Google")]),_vm._v("」をご覧ください。")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DRIP: {
    ID: 1,
    NAME: 'drip',
    METHOD_NAME: 'method.drip',
    BEANS_AMOUNT: 12,
    WATER_AMOUNT: 200,
    MAKE_TIME: 1800,
    IMG: '/static/img/pics/drip.jpg',
    TIME_BLOOM: 300,
    TIME_SECOND_POUR: 900,
    TIME_THIRD_POUR: 1500
  },
  FRENCH: {
    ID: 2,
    NAME: 'french',
    METHOD_NAME: 'method.french',
    BEANS_AMOUNT: 13,
    WATER_AMOUNT: 200,
    MAKE_TIME: 2400,
    IMG: '/static/img/pics/french.jpg',
    TIME_FIRST_MSG: 300
  },
  AERO: {
    ID: 3,
    NAME: 'aero',
    METHOD_NAME: 'method.aero',
    BEANS_AMOUNT: 13,
    WATER_AMOUNT: 200,
    MAKE_TIME: 1200,
    IMG: '/static/img/pics/aero.jpg',
    TIME_FIRST_MSG: 600
  },
  INTERVAL_COUNTUP: 100,
  INTERVAL_DO_COUNTDOWN: 1000
});

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

module.exports = {"ja":{"cmn":{"author":"マタタビ","app-name":"Enjoy Coffee","release-info1":"・ドリップ抽出の抽出時間を2:30〜3:00に変更しました。","release-info2":"・プライバシーポリシーを更新しました。","app-info":"このアプリはコーヒーを淹れるときに必要な豆と水の量を自動計算してくれるアプリです。淹れ方毎の抽出に必要な時間も自動で計算されるので、表示される内容で準備して時間通りに抽出すると美味しいコーヒーが飲めます！","intro-info":"メルボルンで修行された元バリスタ監修のもと制作しています。","ext-info":"次はいくつかの淹れ方を保存できるようにしたいです。","switch-lang":"English","header-message":"バリスタのような体験を！","header-message-ext":"淹れ方に沿ってコーヒーを淹れるとバリスタが淹れたような美味しいコーヒーが召し上がれます。","choose-method":"淹れ方を選ぶ","howto-make":"コーヒーの淹れ方を見る","what-cups":"何杯淹れる？","what-cups-info":"1杯は約180mlで計算します。","cups":" 杯","prepare-material":"以下の量を準備しよう","beans":"コーヒー豆","water":"お湯","make-time":"抽出時間","lets-go":"挽いた豆を器具に入れて、お湯が湧いたらスタート!","until-start":"スタートまで","complete":"美味しいコーヒーができました！"},"method":{"drip":"ドリップ","french":"フレンチプレス","aero":"エアロプレス","drip-msg1":"お湯を %d mlまで豆全体にお湯がいきわたるように注いで、注ぎ始めから30秒間蒸らしましょう！","drip-msg2":"蒸らし完了！ %d mlまで注いでお湯を落としましょう。","drip-msg3":"最後にお湯を %d mlまで注いで抽出時間になったら出来上がりです♪","drip-msg4":"出来上がりの目安時間です！(3:00までに落とし切れたらOKです)","french-msg1":"豆全体にお湯がいきわたるように指定量まで注ぎましょう","french-msg2":"指定時間になったらプレス！","aero-msg1":"豆全体にお湯がいきわたるように指定量まで注ぎましょう","aero-msg2":"抽出時間までかけてゆっくりプレス！"},"item":{"to-blog":"ブログへ","start":"スタート！","stop":"ストップ！","reset":"リセット","close":"閉じる","save":"淹れ方を保存","clear":"初期化"},"howto":{"header-message":"コーヒーの淹れ方","header-message-ext":"淹れ方ごとに詳しい手順を解説します。","drip":{"1":"挽いたコーヒー豆を淹れたい量に合わせて用意します。(豆の量はアプリが計算します)","2":"お湯を沸かします。沸かしている間に、ドリッパーにペーパーフィルターをセットして一度水ですすぎます。","3":"お湯が沸いたらペーパーフィルターをお湯ですすぎます。","4":"挽いたコーヒー豆をペーパーフィルターに投入します。","5":"スケールにカップとドリッパーをセットしてこのアプリのスタートをタップします。","6":"はじめにお湯が豆全体にいきわたるように、豆の倍の量のお湯を「の」を描きながら注ぎます。(注ぐ量はアプリが計算します)","7":"30秒間蒸らします。","8":"次にお湯を全体の半分を「の」を描きながら注ぎます。(注ぐ量はアプリが計算します)","9":"お湯が落ちたら最後に残ったお湯を同じく「の」を描きながら注ぎきります。","10":"お湯が落ちきったら完成です。(2:30〜3:00で落ちきるのがベストです)"},"french":{"1":"挽いたコーヒー豆を淹れたい量に合わせて用意します。(豆の量はアプリが計算します)","2":"お湯を沸かします","3":"フレンチプレスに豆を投入します。","4":"お湯が沸いたらスケールにフレンチプレスをセットします。","5":"このアプリのスタートをタップします。","6":"はじめにお湯が豆全体にいきわたるように、1/3程度お湯を注ぎます。(マドラーなどでかき混ぜた方がより均一になります)","7":"残っているお湯を注ぎきります。","8":"プレスの蓋をセットして、軽く豆を押してお湯に浸かるようにしておきます。","9":"時間が来たらプレスして完成です。"},"aero":{"1":"挽いたコーヒー豆を淹れたい量に合わせて用意します。(豆の量はアプリが計算します)","2":"お湯を沸かします","3":"お湯が沸いたらペーパーフィルターをお湯ですすぎます。(ステンレスフィルターはそのままで)","4":"エアロプレスに豆を投入します。","5":"スケールにカップとエアロプレスをセットしてこのアプリのスタートをタップします。","6":"はじめにお湯が豆全体にいきわたるように、1/3程度お湯を注ぎます。(マドラーなどでかき混ぜた方がより均一になります)","7":"残っているお湯を注ぎきります。","8":"プレスをセットして、カップの上に置きプレスする準備をします。","9":"1分経ったら約1分間かけてゆっくりプレスしながらお湯を落としていきます。","10":"お湯が落ちきったら完成です。"},"link-msg":"こちらから購入できます"},"pp":{"header-message":"プライバシーポリシー"}},"en":{"cmn":{"author":"MATATABI","app-name":"Enjoy Coffee","release-info1":"- We changed the extraction time of drip extraction to 2: 30 - 3: 00.","release-info2":"- Updated privacy policy.","app-info":"(Untranslated) This application is an application that automatically calculates the amount of beans and water required for coffee brewing. The time required for extracting per brewing method is also calculated automatically, so prepare with the contents to be displayed and extract it on time to have delicious coffee!","intro-info":"This is producing under the supervision of former barista trained in Melbourne.","ext-info":"I want to be able to save some way of making it.","switch-lang":"日本語","header-message":"To experience such as barista!","header-message-ext":"When you coffee along the way you brew, you can eat delicious coffee like a barista was brewed.","choose-method":"Choose method","howto-make":"View the how to make","what-cups":"How many cups?","what-cups-info":"One cup is about 180ml.","cups":" cup(s)","prepare-material":"Let's start when have put ground beans to the coffee equipment and bring the water to a boil!","beans":"Coffee Beans","water":"Hot Water","make-time":"Duration","lets-go":"If completed prepare then tap start button.","until-start":"Until the start","complete":"We have delicious coffee!"},"method":{"drip":"Drip","french":"French Press","aero":"Aero Press","drip-msg1":"Let's bloom for 30 seconds from the start of pour for the water %d ml!","drip-msg2":"Blooming done! Next step pour the water %d ml.","drip-msg3":"Last step pour the water until %d ml.","drip-msg4":"Estimated time for completion! (It is OK if it can be dropped until 3:00.)","french-msg1":"Pour the water till the specified amount and make sure all the coffee grounds are wet.","french-msg2":"Let's press at the extraction time!","aero-msg1":"Pour the water till the specified amount and make sure all the coffee grounds are wet.","aero-msg2":"Press slowly over the extraction time!"},"item":{"to-blog":"TO BLOG","start":"START!","stop":"STOP!","reset":"RESET","close":"CLOSE","save":"SAVE SETTINGS","clear":"CLEAR SETTINGS"},"howto":{"header-message":"How to make the coffee.","header-message-ext":"I will explain the detailed procedure for each way of making.","drip":{"1":"Prepare the ground coffee beans according to the amount you want to make.(The amount of beans is calculated by the application)","2":"Boil water. While boiling, set the paper filter on the dripper and rinse with water once.","3":"Rinse the paper filter with hot water when hot water boils.","4":"Put the ground coffee beans into the paper filter.","5":"Set the cup and dripper on the scale and tap the start button of this application.","6":"Introduction Pour hot water throughout the all beans.At this time, pour the hot water of twice the amount of the beans while drawing a circle.(The application calculates the pouring amount)","7":"Bloom for 30 seconds.","8":"Next, pour hot water while drawing a circle in half of the whole.(The application calculates the pouring amount)","9":"When hot water falls, pour out the remaining hot water while drawing a circle.","10":"It will be completed if the hot water falls.(It is best to fall off at 2: 30 - 3: 00)"},"french":{"1":"Prepare the ground coffee beans according to the amount you want to make.(The amount of beans is calculated by the application)","2":"Boil water.","3":"Put the beans into the French press.","4":"When hot water boils, set a French press on the scale.","5":"Tap the start button of this application.","6":"Introduction pour hot water about 1/3 hot water to the all beans.(Mixing with muddler etc. becomes more uniform)","7":"Pour out the remaining hot water.","8":"Set the lid and press lightly to the beans soak in hot water.","9":"When time comes, pressed it and it is completed."},"aero":{"1":"Prepare the ground coffee beans according to the amount you want to make.(The amount of beans is calculated by the application)","2":"Boil water.","3":"Rinse the paper filter with hot water when hot water boils.(When using stainless steel filter, as it is)","4":"Put beans into an aero press.","5":"Set the cup and aero press on the scale and tap the start button of this application.","6":"Introduction pour hot water about 1/3 hot water to the all beans.(Mixing with muddler etc. becomes more uniform)","7":"Pour out the remaining hot water.","8":"Set up the aeropress and put on the cup, prepare to press it.","9":"After one minute, it takes use about over a period of 1 minute to slowly press down and drop the hot water.","10":"It will be completed if the hot water falls."},"link-msg":"You can purchase from here."},"pp":{"header-message":"Privacy Policy"}}}

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      adtag: false
    };
  },
  mounted: function mounted() {
    if (true) {
      this.adtag = true;
    }
    if (localStorage.getItem('version') === null || localStorage.getItem('version') < this.$version) {
      localStorage.setItem('version', this.$version);
      this.showModal();
    }
  },

  methods: {
    switchLanguage: function switchLanguage() {
      if (this.$i18n.locale === 'ja') {
        this.$i18n.locale = 'en';
      } else {
        this.$i18n.locale = 'ja';
      }
    },
    showModal: function showModal() {
      this.$refs.appInfo.show();
    },
    hideModal: function hideModal() {
      this.$refs.appInfo.hide();
    }
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coffee',
  data: function data() {
    return {
      curMethod: null,
      curCups: null,
      curBaseBeansAmount: 0.0,
      calcedWaterAmount: 0,
      makeTime: 0,
      isMaking: false,
      timer: null,
      curTime: 0,
      isShowMsg: false,
      showMsg: '',
      isCompleted: false,
      beforeStart: 3,
      downTimer: null,
      imgPath: this.$constants.DRIP.IMG,
      map: this.getMakeData()
    };
  },

  methods: {
    selectMethod: function selectMethod(methodId) {
      this.curMethod = methodId;
      this.makeTime = this.formatTime(this.map[methodId].makeTime);
      this.imgPath = this.map[methodId].img;
      if (this.curCups !== null) {
        this.selectCup(this.curCups);
      }
    },
    getOptions: function getOptions() {
      return [{ value: null, text: 'msg.choose-method' }, { value: 1, text: this.map[1].method_name }, { value: 2, text: this.map[2].method_name }, { value: 3, text: this.map[3].method_name }];
    },
    selectCup: function selectCup(cups) {
      this.curCups = cups;
      var method = this.map[this.curMethod];
      this.curBaseBeansAmount = method.beansAmount * cups;
      this.calcAmount();
    },
    doCountDown: function doCountDown() {
      var self = this;
      this.downTimer = setInterval(function () {
        self.countDown();
      }, this.$constants.INTERVAL_DO_COUNTDOWN);
    },
    countDown: function countDown() {
      this.beforeStart--;
      if (this.beforeStart < 1) {
        this.countUp();
      }
    },
    countUp: function countUp() {
      clearInterval(this.downTimer);
      var self = this;
      this.timer = setInterval(function () {
        self.counter();
      }, this.$constants.INTERVAL_COUNTUP);
    },
    makeStart: function makeStart() {
      if (this.isCompleted) {
        return;
      }
      this.isMaking = true;
      if (this.beforeStart < 1) {
        this.countUp();
        return;
      }
      this.doCountDown();
    },
    makeStop: function makeStop() {
      this.isMaking = false;
      clearInterval(this.downTimer);
      clearInterval(this.timer);
      if (this.isCompleted) {
        this.showMsg = this.$i18n.t('cmn.complete');
        this.isShowMsg = true;
      }
    },
    makeReset: function makeReset() {
      this.init();
    },
    counter: function counter() {
      this.curTime++;
      this.afterCounter();
    },
    afterCounter: function afterCounter() {
      switch (this.curMethod) {
        case 1:
          if (this.curTime < this.$constants.DRIP.TIME_BLOOM) {
            this.isShowMsg = true;
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg1'), this.curBaseBeansAmount * 2);
          } else if (this.curTime < this.$constants.DRIP.TIME_SECOND_POUR) {
            this.isShowMsg = true;
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg2'), this.calcedWaterAmount / 2);
          } else if (this.curTime < this.$constants.DRIP.TIME_THIRD_POUR) {
            this.isShowMsg = true;
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg3'), this.calcedWaterAmount);
          } else if (this.curTime < this.map[this.curMethod].makeTime) {
            this.isShowMsg = true;
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg4'), this.calcedWaterAmount);
          }
          break;
        case 2:
          if (this.curTime < this.$constants.FRENCH.TIME_FIRST_MSG) {
            this.isShowMsg = true;
            this.showMsg = this.$i18n.t('method.french-msg1');
          } else if (this.map[2].makeTime / 8 <= this.curTime) {
            this.isShowMsg = true;
            this.showMsg = this.$i18n.t('method.french-msg2');
          }
          break;
        case 3:
          if (this.curTime < this.$constants.AERO.TIME_FIRST_MSG) {
            this.isShowMsg = true;
            this.showMsg = this.$i18n.t('method.aero-msg1');
          } else if (this.map[3].makeTime / 2 <= this.curTime) {
            this.isShowMsg = true;
            this.showMsg = this.$i18n.t('method.aero-msg2');
          }
          break;
        default:
          break;
      }
      if (this.map[this.curMethod].makeTime <= this.curTime) {
        this.isCompleted = true;
        this.makeStop();
      }
    },
    plusBeans: function plusBeans() {
      this.curBaseBeansAmount = this.curBaseBeansAmount + 0.1;
      this.calcAmount();
    },
    minusBeans: function minusBeans() {
      this.curBaseBeansAmount = this.curBaseBeansAmount - 0.1;
      this.calcAmount();
    },
    calcAmount: function calcAmount() {
      var method = this.map[this.curMethod];
      if (method.beansAmount === 0 || this.curCups === 0) {
        return;
      }
      var waterRate = (this.curBaseBeansAmount / (method.beansAmount * this.curCups)).toFixed(2);
      this.calcedWaterAmount = (waterRate * method.waterAmount * this.curCups).toFixed(0);
    },
    formatTime: function formatTime(time) {
      var min = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(time / 10 / 60);
      var sec = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(time / 10 % 60);

      return min.toString().padStart(2, 0) + ':' + sec.toString().padStart(2, 0);
    },
    init: function init() {
      if (localStorage.getItem('settings') === null) {
        this.curMethod = null;
        this.curCups = null;
        this.curBaseBeansAmount = 0.0;
        this.calcedWaterAmount = 0;
        this.makeTime = 0;
      } else {
        var settings = JSON.parse(localStorage.getItem('settings'));
        // TODO: must checking value is correct
        this.curMethod = parseInt(settings.method);
        this.curCups = parseInt(settings.cups);
        this.curBaseBeansAmount = parseFloat(settings.beans);
        this.calcedWaterAmount = parseFloat(settings.water);
        this.makeTime = this.formatTime(parseInt(settings.time));
      }
      this.beforeStart = 3;
      this.curTime = 0;
      this.isMaking = false;
      this.showMsg = '';
      this.isShowMsg = false;
      this.isCompleted = false;
    },

    showGram: function showGram() {
      return this.curBaseBeansAmount.toFixed(1) + 'g';
    },
    saveSettings: function saveSettings() {
      var settings = {
        method: this.curMethod,
        cups: this.curCups,
        beans: this.curBaseBeansAmount.toFixed(2),
        water: this.calcedWaterAmount,
        time: this.map[this.curMethod].makeTime
      };
      localStorage.setItem('settings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
    },
    clearSettings: function clearSettings() {
      localStorage.removeItem('settings');
      this.curMethod = null;
      this.curCups = null;
      this.curBaseBeansAmount = 0.0;
      this.calcedWaterAmount = 0;
      this.makeTime = 0;
      this.beforeStart = 3;
    },
    getMakeData: function getMakeData() {
      return {
        1: {
          method_name: this.$constants.DRIP.METHOD_NAME,
          beansAmount: this.$constants.DRIP.BEANS_AMOUNT,
          waterAmount: this.$constants.DRIP.WATER_AMOUNT,
          makeTime: this.$constants.DRIP.MAKE_TIME,
          img: this.$constants.DRIP.IMG
        },
        2: {
          method_name: this.$constants.FRENCH.METHOD_NAME,
          beansAmount: this.$constants.FRENCH.BEANS_AMOUNT,
          waterAmount: this.$constants.FRENCH.WATER_AMOUNT,
          makeTime: this.$constants.FRENCH.MAKE_TIME,
          img: this.$constants.FRENCH.IMG
        },
        3: {
          method_name: this.$constants.AERO.METHOD_NAME,
          beansAmount: this.$constants.AERO.BEANS_AMOUNT,
          waterAmount: this.$constants.AERO.WATER_AMOUNT,
          makeTime: this.$constants.AERO.MAKE_TIME,
          img: this.$constants.AERO.IMG
        }
      };
    }
  },
  computed: {
    showTime: function showTime() {
      var min = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(this.curTime / 10 / 60);
      var sec = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(this.curTime / 10 % 60);
      var ms = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(this.curTime % 10);

      return min.toString().padStart(2, 0) + ':' + sec.toString().padStart(2, 0) + '.' + ms.toString().padStart(1, 0);
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'howto',
  data: function data() {
    return {
      howtoMake: '',
      linkAmazonImg: '',
      linkAmazonText: '',
      curMethod: null,
      imgPath: this.$constants.DRIP.IMG,
      map: this.getMakeData()
    };
  },

  methods: {
    selectMethod: function selectMethod(methodId) {
      this.curMethod = methodId;
      this.imgPath = this.map[methodId].img;
      this.loadHowtoMake();
    },
    getOptions: function getOptions() {
      return [{ value: null, text: 'msg.choose-method' }, { value: 1, text: this.map[1].name }, { value: 2, text: this.map[2].name }, { value: 3, text: this.map[3].name }];
    },
    loadHowtoMake: function loadHowtoMake() {
      var method = null;
      var countMsg = 0;
      switch (this.curMethod) {
        case this.$constants.DRIP.ID:
          method = this.$constants.DRIP.NAME;
          countMsg = 10;
          break;
        case this.$constants.FRENCH.ID:
          method = this.$constants.FRENCH.NAME;
          countMsg = 9;
          break;
        case this.$constants.AERO.ID:
          method = this.$constants.AERO.NAME;
          countMsg = 10;
          break;
      }
      this.howtoMake = '<ol>';
      for (var i = 1; i <= countMsg; i++) {
        var msgCode = this.$sprintf.sprintf('howto.%s.%d', method, i);
        this.howtoMake += this.$sprintf.sprintf('<li>%s</li>', this.$i18n.t(msgCode));
      }
      this.howtoMake += '</ol>';
    },
    init: function init() {},

    showGram: function showGram() {
      return this.curBaseBeansAmount.toFixed(1) + 'g';
    },
    getMakeData: function getMakeData() {
      return {
        1: {
          method_name: this.$constants.DRIP.METHOD_NAME,
          beansAmount: this.$constants.DRIP.BEANS_AMOUNT,
          waterAmount: this.$constants.DRIP.WATER_AMOUNT,
          makeTime: this.$constants.DRIP.MAKE_TIME,
          img: this.$constants.DRIP.IMG
        },
        2: {
          method_name: this.$constants.FRENCH.METHOD_NAME,
          beansAmount: this.$constants.FRENCH.BEANS_AMOUNT,
          waterAmount: this.$constants.FRENCH.WATER_AMOUNT,
          makeTime: this.$constants.FRENCH.MAKE_TIME,
          img: this.$constants.FRENCH.IMG
        },
        3: {
          method_name: this.$constants.AERO.METHOD_NAME,
          beansAmount: this.$constants.AERO.BEANS_AMOUNT,
          waterAmount: this.$constants.AERO.WATER_AMOUNT,
          makeTime: this.$constants.AERO.MAKE_TIME,
          img: this.$constants.AERO.IMG
        }
      };
    }
  },
  computed: {
    showTime: function showTime() {
      var min = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.curTime / 10 / 60);
      var sec = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.curTime / 10 % 60);
      var ms = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.curTime % 10);

      return min.toString().padStart(2, 0) + ':' + sec.toString().padStart(2, 0) + '.' + ms.toString().padStart(1, 0);
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_webfonts_css_fontawesome_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_webfonts_css_fontawesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_webfonts_css_fontawesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_webfonts_css_fa_brands_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_webfonts_css_fa_brands_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_webfonts_css_fa_brands_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_webfonts_css_fa_regular_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_webfonts_css_fa_regular_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_free_webfonts_css_fa_regular_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_webfonts_css_fa_solid_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_webfonts_css_fa_solid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_free_webfonts_css_fa_solid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_google_adsense__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_google_adsense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_google_adsense__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sprintf_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sprintf_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__(224));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_google_adsense___default.a.Adsense);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_google_adsense___default.a.InArticleAdsense);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_google_adsense___default.a.InFeedAdsense);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_sprintf_js___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, {
  id: 'UA-107855771-3',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$version = '1.0.9';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$constants = __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sprintf = __WEBPACK_IMPORTED_MODULE_14_sprintf_js___default.a;

var data = __webpack_require__(225);
var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: 'ja',
  messages: data
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7aa2c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(80);
function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7aa2c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('nav',{staticClass:"navbar app-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"switch-lang align-content-end"},[_c('a',{staticClass:"app-lang",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.switchLanguage()}}},[_vm._v("\n            "+_vm._s(_vm.$t("cmn.switch-lang"))+"\n          ")]),_vm._v(" "),_c('a',{staticClass:"app-info-link",attrs:{"href":"#"},on:{"click":function($event){_vm.showModal()}}},[_c('i',{staticClass:"fa fa-info-circle"})]),_vm._v(" "),_c('b-modal',{ref:"appInfo",staticClass:"app-info",attrs:{"id":"app-info","hide-footer":""}},[_c('p',{staticClass:"app-info-txt"},[_vm._v(_vm._s(_vm.$t('cmn.app-info')))]),_vm._v(" "),_c('p',{staticClass:"app-intro-txt"},[_vm._v(_vm._s(_vm.$t('cmn.intro-info'))),_c('br'),_c('a',{staticClass:"app-intro-link",attrs:{"href":"https://yutamatsumoto.com","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('item.to-blog')))])]),_vm._v(" "),_c('p',[_vm._v("App Version: "+_vm._s(this.$version))]),_vm._v(" "),_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_vm._v("\n                "+_vm._s(_vm.$t('cmn.release-info1'))+"\n              ")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._v("\n                "+_vm._s(_vm.$t('cmn.release-info2'))+"\n              ")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('cmn.ext-info')))]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('item.close')))])],1)],1)])]),_vm._v(" "),_c('main',[_c('router-view'),_vm._v(" "),(_vm.adtag)?_c('div',[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-4519316142120062","data-ad-slot":"7450659277"}})],1):_vm._e()],1),_vm._v(" "),_c('footer',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n        ©"),_c('a',{attrs:{"href":"https://twitter.com/matatabi3","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('cmn.author')))])]),_vm._v(" "),_c('div',{staticClass:"footer-ext"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"icon-by"},[_c('router-link',{staticClass:"link",attrs:{"to":"privacy-policy"}},[_vm._v("Privacy Policy")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-brand"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/icons/logo-white.svg"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-by"},[_vm._v("Icons made by "),_c('a',{attrs:{"href":"http://www.freepik.com","title":"Freepik"}},[_vm._v("Freepik")]),_vm._v(" from "),_c('a',{attrs:{"href":"https://www.flaticon.com/","title":"Flaticon"}},[_vm._v("www.flaticon.com")]),_vm._v(" is licensed by "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by/3.0/","title":"Creative Commons BY 3.0","target":"_blank"}},[_vm._v("CC 3.0 BY")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Coffee__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Howto__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrivacyPolicy__ = __webpack_require__(102);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Coffee',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Coffee__["a" /* default */]
  }, {
    path: '/howto',
    name: 'Howto',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Howto__["a" /* default */]
  }, {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: __WEBPACK_IMPORTED_MODULE_4__components_PrivacyPolicy__["a" /* default */]
  }]
}));

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coffee_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_850e1892_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coffee_vue__ = __webpack_require__(99);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coffee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_850e1892_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coffee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.$t("cmn.header-message")))]),_vm._v(" "),_c('p',{staticClass:"app-msg"},[_vm._v(_vm._s(_vm.$t("cmn.header-message-ext")))])]),_vm._v(" "),_c('div',{staticClass:"img-coffee"},[_c('img',{staticClass:"img-coffee-method",attrs:{"src":_vm.imgPath,"alt":"coffee-image."}})]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('router-link',{staticClass:"link",attrs:{"to":"howto"}},[_vm._v(_vm._s(_vm.$t('cmn.howto-make')))])],1),_vm._v(" "),_c('div',{staticClass:"choose-methods"},[_c('b-form-select',{on:{"change":function($event){_vm.selectMethod($event)}},model:{value:(_vm.curMethod),callback:function ($$v) {_vm.curMethod=$$v},expression:"curMethod"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- "+_vm._s(_vm.$t("cmn.choose-method"))+" --")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t(_vm.map[1].method_name)))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t(_vm.map[2].method_name)))]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v(_vm._s(_vm.$t(_vm.map[3].method_name)))])])],1),_vm._v(" "),(_vm.curMethod)?_c('div',{staticClass:"choose-cups"},[_c('b-form-select',{on:{"change":function($event){_vm.selectCup($event)}},model:{value:(_vm.curCups),callback:function ($$v) {_vm.curCups=$$v},expression:"curCups"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- "+_vm._s(_vm.$t("cmn.what-cups"))+" --")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("1"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":1.5}},[_vm._v("1.5"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("2"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":2.5}},[_vm._v("2.5"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v("3"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":3.5}},[_vm._v("3.5"+_vm._s(_vm.$t("cmn.cups")))]),_vm._v(" "),_c('option',{domProps:{"value":4}},[_vm._v("4"+_vm._s(_vm.$t("cmn.cups")))])]),_vm._v(" "),_c('span',{staticClass:"msg-what-cups-info small text-secondary"},[_vm._v(_vm._s(_vm.$t("cmn.what-cups-info")))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prepare-info"},[(_vm.curMethod && _vm.curCups)?_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item border-top-0 border-left-0 border-right-0"},[_c('span',{staticClass:"prepare-msg"},[_vm._v(_vm._s(_vm.$t('cmn.prepare-material')))])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"prepare-beans"},[_c('span',{staticClass:"prepare-beans-text"},[_vm._v(_vm._s(_vm.$t('cmn.beans'))+":")]),_vm._v(" "),(!_vm.isMaking)?_c('button',{staticClass:"btn btn-minus",attrs:{"type":"button"},on:{"click":_vm.minusBeans}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prepare-calced-beans-text"},[_vm._v(_vm._s(this.showGram()))]),_vm._v(" "),(!_vm.isMaking)?_c('button',{staticClass:"btn btn-plus",attrs:{"type":"button"},on:{"click":_vm.plusBeans}},[_vm._m(1)]):_vm._e()])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"prepare-water"},[_vm._v(_vm._s(_vm.$t('cmn.water'))+": "+_vm._s(_vm.calcedWaterAmount)+" ml")])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"prepare-clock"},[_c('i',{staticClass:"fa fa-clock"}),_vm._v(" "+_vm._s(_vm.$t('cmn.make-time'))+": "+_vm._s(_vm.makeTime))])])]):_vm._e()]),_vm._v(" "),(_vm.curBaseBeansAmount && _vm.calcedWaterAmount)?_c('ul',{staticClass:"list-group calc-box"},[_c('li',{staticClass:"list-group-item border-top-0 border-left-0 border-right-0"},[_c('span',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.$t('cmn.lets-go')))])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"make-timer"},[_vm._v(_vm._s(_vm.showTime))]),_vm._v(" "),(_vm.isShowMsg)?_c('div',[_c('span',{staticClass:"msg-additional-info"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "+_vm._s(_vm.showMsg))])]):_vm._e(),_vm._v(" "),(_vm.beforeStart)?_c('div',{staticClass:"count-down"},[_c('p',{staticClass:"count-down-before"},[_vm._v(_vm._s(_vm.$t('cmn.until-start')))]),_c('span',{staticClass:"count-down-timer"},[_vm._v(_vm._s(_vm.beforeStart))])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"list-group-item calc-btns border-right-0 border-left-0 border-bottom-0"},[(!_vm.isMaking)?_c('div',[_c('button',{staticClass:"btn btn-outline-success btn-start",on:{"click":function($event){_vm.makeStart()}}},[_vm._v("\n          "+_vm._s(_vm.$t('item.start'))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.isMaking)?_c('div',[_c('button',{staticClass:"btn btn-success btn-stop",on:{"click":function($event){_vm.makeStop()}}},[_vm._v("\n          "+_vm._s(_vm.$t('item.stop'))+"\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isMaking)?_c('div',[_c('button',{staticClass:"btn btn-outline-info btn-reset",on:{"click":function($event){_vm.makeReset()}}},[_vm._v("\n          "+_vm._s(_vm.$t('item.reset'))+"\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isMaking)?_c('div',[_c('div',{staticClass:"btns-save"},[_c('button',{staticClass:"btn btn-outline-secondary btn-save",on:{"click":function($event){_vm.saveSettings()}}},[_vm._v("\n            "+_vm._s(_vm.$t('item.save'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger btn-clear",on:{"click":function($event){_vm.clearSettings()}}},[_vm._v("\n            "+_vm._s(_vm.$t('item.clear'))+"\n          ")])])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-light"},[_c('i',{staticClass:"fa fa-minus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-light"},[_c('i',{staticClass:"fa fa-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[73]);


// WEBPACK FOOTER //
// static/js/app.bbce12e5d53993693fa3.js